import {login, logout} from '@/api/user'
import {getToken, setToken, removeToken} from '@/utils/auth'
import {resetRouter} from '@/router'

// 初始状态
const state = {
    token: getToken(), name: '游客', avatar: '', introduction: '', roles: [], mobile: '', id: '', isPay: false,
}
// 修改状态
const mutations = {
    SET_TOKEN: (state, token) => {
        state.token = token
    }, SET_INTRODUCTION: (state, introduction) => {
        state.introduction = introduction
    }, SET_NAME: (state, name) => {
        state.name = name
    }, SET_AVATAR: (state, avatar) => {
        state.avatar = avatar
    }, SET_ROLES: (state, roles) => {
        state.roles = roles
    }, SET_MOBILE: (state, mobile) => {
        state.mobile = mobile
    }, SET_LOGIN_ID: (state, id) => {
        state.id = id
    }, SET_IS_PAY: (state, isPay) => {
        state.isPay = isPay
    }

}

// 异步操作
const actions = {
    // 登录
    login({commit}, userInfo) {
        const {userName} = userInfo
        localStorage.setItem('SET_NAME', userName)
        commit('SET_NAME', userName)

        return new Promise((resolve, reject) => {
            login(userInfo).then(response => {
                const {data} = response
                if (response.code === 0) {
                    setToken(data.token)
                    commit('SET_TOKEN', data.token)
                    resolve(response)
                } else {
                    // 登录失败：响应体 code（401=密码错误，429=锁定），由登录页展示提示
                    reject(response)
                }
            }).catch(error => {
                reject(error)
            })
        })
    },

    // 登出（服务端会立即吊销 token）
    logout({commit, state}) {
        return new Promise((resolve) => {
            const clearLoginState = () => {
                commit('SET_TOKEN', '')
                commit('SET_ROLES', [])
                removeToken()
                resetRouter()
                resolve()
            }
            logout(state.token).then(() => {
                clearLoginState()
            }).catch(() => {
                // 即使后端登出失败（如 token 已过期），也要清除本地登录态
                clearLoginState()
            })
        })
    },

    // 重置token
    resetToken({commit}) {
        return new Promise(resolve => {
            commit('SET_TOKEN', '')
            commit('SET_ROLES', [])
            removeToken()
            resolve()
        })
    }
}

export default {
    namespaced: true, state, mutations, actions
}
